import { useEffect } from "react";

const setTag = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export default function useMeta(title, description) {
  useEffect(() => {
    const full = `${title} | Violet Psychotherapy`;
    document.title = full;
    setTag("name", "description", description);
    setTag("property", "og:title", full);
    setTag("property", "og:description", description);
    setTag("property", "og:url", window.location.href);
  }, [title, description]);
}
